import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { FLASH_OFFERS_QUERY } from '../graphql';
import { personaLabel } from '../config/personas';

// Flashes every seller's "offer of the day" (1+1, free tasters, % off) in a
// dismissible marquee strip pinned to the top of the app.
export default function OffersBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { data } = useQuery(FLASH_OFFERS_QUERY, {
    pollInterval: 60 * 1000, // refresh every minute
    fetchPolicy: 'cache-and-network',
  });
  const offers = data?.flashOffers || [];
  if (dismissed || offers.length === 0) return null;

  // Duplicate the list so the marquee scroll is seamless.
  const loop = [...offers, ...offers];

  return (
    <div style={{
      position: 'relative', background: 'linear-gradient(90deg, var(--primary), #ec4899)',
      color: '#fff', overflow: 'hidden', display: 'flex', alignItems: 'center', height: 38,
    }}>
      <span style={{ flexShrink: 0, fontWeight: 800, fontSize: 12, padding: '0 12px', background: 'rgba(0,0,0,0.15)', height: '100%', display: 'flex', alignItems: 'center', letterSpacing: 0.5 }}>
        ⚡ OFFERS OF THE DAY
      </span>
      <div style={{ overflow: 'hidden', flex: 1 }}>
        <div className="offers-marquee" style={{ display: 'inline-flex', gap: 28, whiteSpace: 'nowrap', animation: 'offersScroll 30s linear infinite', paddingLeft: 20 }}>
          {loop.map((o, i) => (
            <span key={o.id + '_' + i} style={{ fontSize: 13, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              {o.offerLabel && <span style={{ background: '#fff', color: 'var(--primary)', fontWeight: 800, borderRadius: 4, padding: '1px 7px', fontSize: 11 }}>{o.offerLabel}</span>}
              <span>{o.description || `${o.discountPct}% off`}</span>
              <span style={{ opacity: 0.85 }}>· code <b style={{ fontFamily: 'monospace' }}>{o.code}</b></span>
              <span style={{ opacity: 0.8 }}>· {o.sellerName}{o.sellerPersona ? ` (${personaLabel(o.sellerPersona)})` : ''}</span>
            </span>
          ))}
        </div>
      </div>
      <button onClick={() => setDismissed(true)} aria-label="Dismiss offers"
        style={{ flexShrink: 0, background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 16, padding: '0 12px', height: '100%' }}>✕</button>
      <style>{`@keyframes offersScroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}
